import { AccountState } from './types';

export const ACCOUNT_SLICE_NAME = 'account';

export const ACCOUNT_INITIAL_STATE: AccountState = {
  loading: false,
  error: null,
  lastFetchTime: null,
  dataStale: false,

  userId: '',
  currentCompanyId: '',
  companyIds: [],
  streamLibraryId: '',
  isBillingEnabled: false,

  isReadyToUseLK: false,
  isAuthorized: false,
  isWithoutCompanies: false,
};

export const ACCOUNT_STORAGE_KEYS = {
  SELECTED_COMPANY_ID: 'account_selected_company_id',
  LAST_FETCH_TIME: 'account_last_fetch_time',
};

export const ACCOUNT_FETCH_CONFIG = {
  staleTime: 5 * 60 * 1000,
  retryCount: 3,
  retryDelay: 1000,
};
